export default {
	objTiers: [],
    basePrice: 0
}
